import { render, staticRenderFns } from "./DefaultCartsDetail.vue?vue&type=template&id=5ae1c06e&"
import script from "./DefaultCartsDetail.vue?vue&type=script&lang=js&"
export * from "./DefaultCartsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCartsDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports